import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_4 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_5 = {
  key: 3,
  class: "table table-bordered table-hover"
}
const _hoisted_6 = ["onDblclick"]
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = ["disabled", "onClick"]
const _hoisted_9 = ["disabled", "onClick"]
const _hoisted_10 = { class: "text-muted small" }
const _hoisted_11 = {
  key: 0,
  class: "small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NonAvailabilityGroupEditModal = _resolveComponent("NonAvailabilityGroupEditModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("h4", null, "Holiday Requests", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("label", {
        class: "form-label me-2",
        for: "statusFilter"
      }, "Status", -1)),
      _withDirectives(_createElementVNode("select", {
        id: "statusFilter",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.selectedStatus) = $event)),
        class: "form-select form-select-sm d-inline-block",
        style: {"width":"200px"},
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.fetchRequests && $options.fetchRequests(...args)))
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("option", { value: "Pending" }, "Pending", -1),
        _createElementVNode("option", { value: "Approved" }, "Approved", -1),
        _createElementVNode("option", { value: "Rejected" }, "Rejected", -1),
        _createElementVNode("option", { value: "All" }, "All", -1)
      ]))], 544), [
        [_vModelSelect, $data.selectedStatus]
      ])
    ]),
    ($data.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("div", { class: "spinner-border text-primary" }, [
            _createElementVNode("span", { class: "visually-hidden" })
          ], -1),
          _createTextVNode(" Loading... ", -1)
        ]))]))
      : _createCommentVNode("", true),
    ($data.message)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["alert", $data.messageType]),
          role: "alert"
        }, _toDisplayString($data.message), 3))
      : _createCommentVNode("", true),
    (!$data.loading && $data.requests.length === 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, "No requests."))
      : _createCommentVNode("", true),
    ($data.requests.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_5, [
          _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Officer"),
              _createElementVNode("th", null, "Type"),
              _createElementVNode("th", null, "Dates"),
              _createElementVNode("th", null, "Reason"),
              _createElementVNode("th", null, "Requested By"),
              _createElementVNode("th", null, "Requested On"),
              _createElementVNode("th", null, "Status"),
              _createElementVNode("th", null, "Decision")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.requests, (request) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: request.recurrenceGroupId,
                onDblclick: ($event: any) => ($options.openGroupEditor(request))
              }, [
                _createElementVNode("td", null, _toDisplayString(request.securityOfficerName), 1),
                _createElementVNode("td", null, _toDisplayString(request.nonAvailabilityTypeName), 1),
                _createElementVNode("td", null, _toDisplayString($options.formatDateRange(request)) + " (" + _toDisplayString(request.dayCount) + " day" + _toDisplayString(request.dayCount === 1 ? "" : "s") + ")", 1),
                _createElementVNode("td", null, _toDisplayString(request.reason), 1),
                _createElementVNode("td", null, _toDisplayString(request.requestedByOperatorName), 1),
                _createElementVNode("td", null, _toDisplayString($options.formatDate(request.requestedDate)), 1),
                _createElementVNode("td", null, _toDisplayString(request.status), 1),
                _createElementVNode("td", null, [
                  (request.status === 'Pending')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control form-control-sm mb-1",
                          "onUpdate:modelValue": ($event: any) => (($data.comments[request.recurrenceGroupId]) = $event),
                          placeholder: "Comment (optional)"
                        }, null, 8, _hoisted_7), [
                          [_vModelText, $data.comments[request.recurrenceGroupId]]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-success me-1",
                          disabled: $data.actioningGroupId === request.recurrenceGroupId,
                          onClick: ($event: any) => ($options.decide(request, 'Approve'))
                        }, " Approve ", 8, _hoisted_8),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-outline-danger",
                          disabled: $data.actioningGroupId === request.recurrenceGroupId,
                          onClick: ($event: any) => ($options.decide(request, 'Reject'))
                        }, " Reject ", 8, _hoisted_9)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", null, _toDisplayString(request.approvedByOperatorName), 1),
                        _createElementVNode("div", _hoisted_10, _toDisplayString($options.formatDate(request.approvedDate)), 1),
                        (request.approvalComment)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(request.approvalComment), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                ])
              ], 40, _hoisted_6))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    ($data.editingGroupId)
      ? (_openBlock(), _createBlock(_component_NonAvailabilityGroupEditModal, {
          key: 4,
          "base-url": $props.baseUrl,
          "recurrence-group-id": $data.editingGroupId,
          "all-records": $data.editingRecords,
          "non-availability-types": $data.nonAvailabilityTypes,
          onClose: _cache[2] || (_cache[2] = ($event: any) => ($data.editingGroupId = null)),
          onSaved: $options.onGroupSaved
        }, null, 8, ["base-url", "recurrence-group-id", "all-records", "non-availability-types", "onSaved"]))
      : _createCommentVNode("", true)
  ]))
}